import index from "./niitlelPost.vue";
export default index;
